import { render, staticRenderFns } from "./NewsletterView.vue?vue&type=template&id=2509a860&"
import script from "./NewsletterView.vue?vue&type=script&lang=js&"
export * from "./NewsletterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports